import { render, staticRenderFns } from "./authLogo.vue?vue&type=template&id=90467f36&"
import script from "./authLogo.vue?vue&type=script&lang=js&"
export * from "./authLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports